import React, {useMemo} from 'react';
import {useDropzone} from 'react-dropzone';
import pdfjsLib from 'pdfjs-dist/webpack';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderRadius: 5,
    border: '2px solid #FF1552',
    backgroundColor: '#F8F8F8',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    marginTop: 20,
    height: 200,
    verticalAlign: 'center' 
  };
  
  const activeStyle = {
    borderColor: '#FF1552'
  };
  
  const acceptStyle = {
    borderColor: '#00e676'
  };
  
  const rejectStyle = {
    borderColor: '#ff1744'
  };
  

const Basic = (props) => {
    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
    } = useDropzone({accept: "application/pdf", onDropAccepted: (acceptedFiles) => {
        let filename = acceptedFiles[0].name.substring(0, acceptedFiles[0].name.length - 4);

        MySwal.fire({
            title: "Analizzo il PDF",
            allowOutsideClick: () => !Swal.isLoading(),
            didOpen: () => {
                Swal.showLoading()
                parsePDFLabels(acceptedFiles).then((fileOrders) => {
                    let html = "<ul style='text-align: left'>";
                    fileOrders.map((order) => {
                        html += "<li><b>" + order.reference + "</b> : " + order.traking + "</li>";
                    })
                    html += "<ul>";
                    Swal.fire({
                        title: 'File: ' + filename,
                        html: html, 
                        confirmButtonText: "Carica",
                        cancelButtonText: "Annulla",
                        showCancelButton: true,
                        confirmButtonColor: '#FF1552',
                        cancelButtonColor: "#141413",
                        showLoaderOnConfirm: true,
                        preConfirm: () => {
                            return fetch(process.env.REACT_APP_API_URL + "/group/add", {
                                method: "POST", 
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': "Bearer " + localStorage.getItem("BEARER_TOKEN")
                                    
                                },
                                redirect: 'follow',
                                body: JSON.stringify({groupName: filename, orders: fileOrders})
                            })
                            .then(response => {
                                
                                if (response.status === 524) {
                                    Swal.fire(
                                        'Etichette parzialmente caricate',
                                        'Tutte le etichette sono ancora in fase di caricamento. Puoi continuare ad usare l\'app ma ci vorrà un pò prima che tutte le etichette di questo file siano disponibili.',
                                        'warning'
                                    )
                                } else {
                                    Swal.fire(
                                        'Etichette caricate!',
                                        'Tutte le etichette sono state caricate',
                                        'success'
                                    )
                                }
                                if (!response.ok) {
                                    console.error(response.statusText)
                                }

                                return response.json()
                            })

                        },
                        allowOutsideClick: () => !Swal.isLoading()
                        
                    }).then((result) => {
                        if (result.ok) {
                            let html = "<ul style='text-align: left'>";
                            result.value.erroredOrders.forEach((order) => {
                                html += "<li><b style='color: red'>" + order.reference + "</b> : " + order.traking + "</li>";
                            })
                            result.value.succededOrders.forEach((order) => {
                                html += "<li><b style='color: green'>" + order.reference + "</b> : " + order.traking + "</li>";
                            })
                            html += "<ul>";
                            Swal.fire({
                                title: 'Risultato caricamento',
                                html: html, 
                                confirmButtonText: "Ok",
                                showCancelButton: false,
                                confirmButtonColor: '#FF1552',
                            });
                        }
                    })
                })
            }
            
        })
    }});


    function parsePDFLabels(acceptedFiles) {
        return new Promise((resolve, reject) => {
            return acceptedFiles[0].arrayBuffer().then(e => {
                let buffer = new Uint8Array(e);

                
                pdfjsLib.getDocument(buffer).then(function (PDFDocumentInstance) {
                    const totalPages = PDFDocumentInstance.pdfInfo.numPages;
                    

                    let fileOrders = [];
                    for (let page = 1; page <= totalPages; page++) {
                        getPageText(page , PDFDocumentInstance).then((textPage) => {      
                            const GLSNumber = /AK\s[0-9]{9}\s/g;
                            const MYReference = /Numero ordine: [a-zA-Z,]*/gm;
                            let m = 0, i = 0;
    
                            let pageOrderArray = [];
    
                            while ((m = GLSNumber.exec(textPage)) !== null) {
                                if (m.index === GLSNumber.lastIndex) {
                                    GLSNumber.lastIndex++;
                                }
                                pageOrderArray[i] = m[0];
                                i++;
    
                            }
    
                            i = 0;
                            while ((m = MYReference.exec(textPage)) !== null) {
                                if (m.index === MYReference.lastIndex) {
                                    MYReference.lastIndex++;
                                }
                                pageOrderArray[i] = {
                                    traking: pageOrderArray[i].replaceAll(" ", ""),
                                    reference: m[0].substr(15)
                                }
                                i++;
                            }
                            fileOrders[page-1] = pageOrderArray;
                            if (fileOrders.length === totalPages) {
                                resolve(fileOrders.flat(5));
                            }

                        }).catch(() => {
                            reject();
                        });
                    }
                }, function (reason) {
                    reject();
                });
            })
        });
    }


    const style = useMemo(() => ({
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isDragActive,
        isDragReject,
        isDragAccept
    ]);

    return (
        <div className="container">
            <div {...getRootProps({style})}>
                <input {...getInputProps()} />
                <p style={{color: "#141413", fontSize: 25,margin: "auto"}}>Trascina il PDF delle etichette o clicca per selezionare</p>
            </div>
        </div>
    );
}

function getPageText(pageNum, PDFDocumentInstance) {
    // Return a Promise that is solved once the text of the page is retrieven
    return new Promise((resolve, reject) => { 
        PDFDocumentInstance.getPage(pageNum).then(function (pdfPage) {
            // The main trick to obtain the text of the PDF page, use the getTextContent method
            pdfPage.getTextContent().then(function (textContent) {
                var textItems = textContent.items;
                var finalString = "";

                // Concatenate the string of the item to the final string
                for (var i = 0; i < textItems.length; i++) {
                    var item = textItems[i];

                    finalString += item.str + " ";
                }

                resolve(finalString);
            });
        });
    });
}

Basic.whyDidYouRender= false; // this is the new line
export default Basic;